import React, {} from 'react';
import {Navigate, Route, Routes } from "react-router-dom";
import Usuarios from "../modulos/usuarios/Usuarios";
import FormUsuario from '../modulos/usuarios/FormUsuario';
// import GoogleMap from '../modulos/mapas/UbicacionMapa';


import CaractTransporte from "../modulos/caracteristicatransporte/CaractTransporte";
import FormAddCaractTransporte from '../modulos/caracteristicatransporte/FormAddCaractTransporte';

import TipoTransporte from "../modulos/tipotransporte/TipoTransporte";
import FormAddTipoTransporte from '../modulos/tipotransporte/FormAddTipoTransporte';

import ConfRutaCharter from "../modulos/confrutacharter/ConfRutaCharter";
import FormConfRutaCharter from '../modulos/confrutacharter/FormConfRutaCharter';

import ViajesChofer from "../modulos/viajeschofer/ViajesChofer";

import ViajeCharter from "../modulos/viajecharter/ViajeCharter";
import FormAddViajeCharter from '../modulos/viajecharter/FormAddViajeCharter';
import FormModViajeCharter from '../modulos/viajecharter/FormModViajeCharter';

import TipoRuta from "../modulos/tiporuta/TipoRuta";
import FormAddTipoRuta from '../modulos/tiporuta/FormAddTipoRuta';

import ViajePersonalizado from "../modulos/viajepersonalizado/ViajePersonalizado";
import FormViajePersonalizado from '../modulos/viajepersonalizado/FormViajePersonalizado';

import ViajeCorporativo from "../modulos/viajecorporatitvo/ViajeCorporativo";
import FormViajeCorporativo from '../modulos/viajecorporatitvo/FormViajeCorporativo';

import SolicViajeCharter from "../modulos/solicviajecharter/SolicViajeCharter";
import StepSolicViajeCharter from '../modulos/solicviajecharter/StepSolicViajeCharter';
import FormModSolicViajeCharter from '../modulos/solicviajecharter/FormModSolicViajeCharter';

import Oferta from "../modulos/oferta/Oferta";
import HistorialOfertas from '../modulos/oferta/HistorialOfertas';

import PageWelcome from '../generales/PageWelcome';
import Omnibus from '../modulos/omnibus/Omnibus';
import FormOmnibus from '../modulos/omnibus/FormOmnibus';
import FormRevisionTecnica from '../modulos/omnibus/FormRegRevTecnica';
import FormChangePassword from './FormChangePassword';
import StepsSolicViajeCharter from '../modulos/solicviajecharter/StepsSolicViajeCharter';


const RoutersSystem = () => {

    let funcionalidades = (sessionStorage.getItem('funcionalidades'))? JSON.parse(sessionStorage.getItem('funcionalidades')):null;
  
    return (
            <Routes>

                <Route exact path="/principal" element={<PageWelcome />} />
                <Route path="*" element={<Navigate to='/principal' />} />
                
                /**  Todos los usuarios tendrán permiso a cambiar su propia clave  */ 
                <Route path="/changemypass/:id" element={<FormChangePassword />} />

                {funcionalidades.indexOf("menu_usuarios")!==-1 &&
                       //Gestión de usuarios
                     <>
                         <Route exact path="/usuarios" element={<Usuarios />} />
                         <Route path="/addusuarios" element={<FormUsuario accion = "add"/>} />
                         <Route path="/editusuarios/:id" element={<FormUsuario accion = "mod"/>} />
                         <Route path="/cambiarpass/:id" element={<FormUsuario accion = "pass"/>} />
                     </>
                }

                {funcionalidades.indexOf("menu_transporte")!==-1 &&
                      //Características de Transporte  y  Tipo de Transporte
                    <>
                        <Route exact path="/caracttransporte" element={<CaractTransporte />} />
                        <Route path="/addcaracttransporte" element={<FormAddCaractTransporte accion = "add"/>} />
                        <Route path="/editcaracttransporte/:id" element={<FormAddCaractTransporte accion = "mod"/>} />


                        <Route exact path="/tipotransporte" element={<TipoTransporte />} />
                        <Route path="/addtipotransporte" element={<FormAddTipoTransporte accion = "add"/>} />
                        <Route path="/edittipotransporte/:id" element={<FormAddTipoTransporte accion = "mod"/>} />
                    
                        <Route exact path="/omnibus" element={<Omnibus />} />
                        <Route path="/addomnibus" element={<FormOmnibus accion = "add"/>} />
                        <Route path="/editomnibus/:id" element={<FormOmnibus accion = "mod"/>} />
                        <Route path="/revisiontecnica/:id" element={<FormRevisionTecnica accion = "add"/>} />

                    </>
                }

                {funcionalidades.indexOf("menu_rutas")!==-1 &&
                      //Configurar Ruta Charter  y  Viaje Charter
                    <>
                        <Route exact path="/confrutacharter" element={<ConfRutaCharter />} />
                        <Route path="/addconfrutacharter" element={<FormConfRutaCharter accion = "add"/>} />
                        <Route path="/editconfrutacharter/:id" element={<FormConfRutaCharter accion = "mod"/>} />

                        <Route exact path="/tiporuta" element={<TipoRuta />} />
                        <Route path="/addtiporuta" element={<FormAddTipoRuta accion = "add"/>} />
                        <Route path="/edittiporuta/:id" element={<FormAddTipoRuta accion = "mod"/>} />

                    </>
                }

                {funcionalidades.indexOf("menu_viajes")!==-1 &&
                    //Configurar Ruta Charter  y  Viaje Charter
                    <>

                        <Route exact path="/viajecharter" element={<ViajeCharter />} />
                        <Route path="/addviajecharter" element={<FormAddViajeCharter />} />
                        <Route path="/editviajecharter/:id" element={<FormModViajeCharter/>} />


                    </>
                }

                {funcionalidades.indexOf("menu_viajes_chofer")!==-1 &&
                //Componente para visualizar los viajes del chofer
                <>

                    <Route exact path="/viajeschofer" element={<ViajesChofer />} />


                </>
                }

                {funcionalidades.indexOf("menu_solicitudes")!==-1 &&

                <>
                    {/*Solicitar Viaje Personalizado*/}
                    <Route exact path="/viajepersonalizado" element={<ViajePersonalizado />} />
                    <Route path="/addviajepersonalizado" element={<FormViajePersonalizado accion = "add"/>} />
                    <Route path="/editviajepersonalizado/:id" element={<FormViajePersonalizado accion = "mod"/>} />

                    {/*Solicitar Viaje Corporativo*/}
                    <Route exact path="/viajecorporativo" element={<ViajeCorporativo />} />
                    <Route path="/addviajecorporativo" element={<FormViajeCorporativo accion = "add"/>} />
                    <Route path="/editviajecorporativo/:id" element={<FormViajeCorporativo accion = "mod"/>} />

                    {/*Solicitar Viaje Charter*/}
                    <Route exact path="/solicviajecharter" element={<SolicViajeCharter />} />
                    <Route path="/addsolicviajecharter" element={<StepsSolicViajeCharter/>} />
                    <Route path="/editsolicviajecharter/:id" element={<FormModSolicViajeCharter accion = "mod"/>} />

                </>
                }

                {funcionalidades.indexOf("menu_ofertas")!==-1 &&

                <>
                    {/*Ofertas*/}
                    <Route exact path="/ofertas" element={<Oferta />} />
                    <Route path="/verhistorial" element={<HistorialOfertas />} />

                </>
                }

 
            </Routes>
    );
};

export default RoutersSystem;